import ResultsFormatterBase from "../../formatters/ResultsFormatterBase.js";
import resultsSorter from "../../sorters/resultsSorter.js";

class ResultsOrderFormatter extends ResultsFormatterBase{
    format(results){
        if (results && results instanceof Array){
            results.sort(resultsSorter);
        }

        return results;
    }
};

export default ResultsOrderFormatter;